import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M19.575 20.5c-1.942 0-3.877-.432-5.803-1.297-1.926-.865-3.687-2.095-5.284-3.691-1.59-1.597-2.818-3.359-3.686-5.286C3.934 8.298 3.5 6.365 3.5 4.425V3.5h5.17l.886 4.554-2.773 2.692c.411.72.852 1.39 1.32 2.009.47.618.966 1.184 1.49 1.697a14.287 14.287 0 0 0 1.697 1.479c.624.464 1.316.91 2.08 1.338l2.755-2.804 4.375.89V20.5zM6.073 9.327l1.871-1.785L7.442 5H5.015c.052.756.165 1.493.342 2.209.176.716.415 1.422.716 2.118m8.7 8.642c.641.296 1.325.53 2.051.7.726.17 1.452.27 2.176.3v-2.402l-2.37-.475z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }